import React, { useEffect, useState } from "react";
import {
  Paper,
  Typography,
  Stack,
  TextField,
  Button,
  InputLabel,
  Select,
  MenuItem,
  Box,
  FormControl,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  InputBase,
  IconButton,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link as LinkRRD, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NoDataFound from "../../common/NoDataFound";
import LoadingUI from "../../common/LoadingUI";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import { dateFormatStartFun } from "../../helper/dateConverter";
import DrawerUI from "../../common/DrawerUI";
import AppbarUI from "../../common/AppbarUI";
import { Helmet } from "react-helmet";
import BodyWapperUI from "../../common/BodyWapperUI";
import { DatePicker } from "@mui/x-date-pickers";
import { appListAction } from "../../redux/toolkit/apps/list";
import { charegBackAction } from "../../redux/toolkit/charegBack/chargeback";
import LabelText from "../../common/LabelText";
import SearchIcon from "@mui/icons-material/Search";


const ChargeBack = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [publisher_id, setPublisher_id] = useState();
  const [pagination, setPagination] = useState({ page: 0, limit: 25 });
  const [email, setEmail] = useState("");
  const [selectedApp, setSelectedApp] = useState({});
  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });

  const chargeBack = useSelector((state) => state.chargeBackData);
  const {
    status,
    data,
    loading: listLoading,
    total,
    totalChargeBackSum,
  } = chargeBack;
  const { data: appData } = useSelector((state) => state.appLists);

  const dateWiseUser = () => {
    dispatch(
      charegBackAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
        app_id: selectedApp?._id,
      })
    );
  };

  useEffect(() => {
    dispatch(
      charegBackAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
        app_id: selectedApp?._id,
      })
    );
  }, [selectedApp]);

  useEffect(() => {
    dispatch(
      charegBackAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
        app_id: selectedApp?._id,
      })
    );
  }, [dispatch, pageState.page, pageState.pageSize]);

  useEffect(() => {
    dispatch(appListAction({ is_deleted: false }));
  }, [dispatch]);

  const AppColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },
    {
      field: "publisher_payout",
      headerName: "Publisher Payout (USD)",
      flex: 1,
      minWidth: 180,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return Math.abs(params?.row?.publisher_payout).toFixed(4);
      },
    },

    {
      field: "user_payout",
      headerName: "User Payout (USD)",
      flex: 1,
      minWidth: 150,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return Math.abs(params?.row?.user_payout).toFixed(4);
      },
    },
    {
      field: "trans_id",
      headerName: "Transaction ID",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "user_id",
      headerName: "User Id",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 130,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "createdAt",
      headerName: "Created At",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return moment(params?.value).local().format("DD-MM-YYYY hh:mm:ss A");
      },
    },
  ];

  const handlePageChange = (params) => {
    setPagination((prevState) => ({
      ...prevState,
      page: params.page,
    }));
  };

  const handlePageSizeChange = (params) => {
    setPagination((prevState) => ({
      ...prevState,
      page: 1,
      pageSize: params.pageSize,
    }));
  };

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    const app = appData.find((item) => item.app_name === selectedValue); // Find the full object
    setSelectedApp(app); // Set the entire object
  };

  const [userId, setUserId] = useState("");

  const searchHandler = () => {
    dispatch(
      // userListAction({
      //   page: pageState.page,
      //   limit: pageState.pageSize,
      //   userId: userId,
      // })

      charegBackAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
        app_id: selectedApp?._id,
        userId: userId,

      })
    );
  };

  return (
    <>
      <Helmet>
        <title> Real Opinion Publisher | CharBack </title>
      </Helmet>
      <AppbarUI />
      <DrawerUI />
      <BodyWapperUI>

          <Grid item xs={12} sm={6} md={3}>
            <LabelText text="Search By UserId on chargeback page" />
            <Paper
              elevation={0}
              component="form"
              sx={{
                border: "1px solid rgba(217, 217, 217, 1)",
                height: 40,
                display: "flex",
                alignItems: "center",
                width: { xs: "100%", sm: 400 },
                backgroundColor: "transparent",
                marginTop: "0px !important",
              }}
            >
              <InputBase
                size="small"
                sx={{ ml: 1, flex: 1 }}
                placeholder="Search Here"
                inputProps={{ "aria-label": "search UserId" }}
                onChange={(e) => setUserId(e.target.value)}
              />
              <IconButton
                type="button"
                sx={{ p: "10px" }}
                aria-label="search"
                onClick={searchHandler}
              >
                <SearchIcon />
              </IconButton>
            </Paper>
          </Grid>
        <Grid container spacing={2} sx={{ mt: 3 }}>
      
          {/* Select App */}
          <Grid item xs={12} sm={6} md={3}>
            <FormControl size="small" fullWidth>
              <LabelText text="Select App" />
              <Select
                displayEmpty
                id="select"
                value={selectedApp?.app_name || ""}
                onChange={handleChange}
              >
                <MenuItem value="">
                  <em>Select an app</em>
                </MenuItem>
                {appData?.map((item, i) => (
                  <MenuItem key={i} value={item.app_name}>
                    {item.app_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Start Date */}
          <Grid item xs={12} sm={6} md={3}>
            <LabelText text="Start Date" />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, startDate: newValue });
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    fullWidth
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      placeholder: "Start Date", // force it inside inputProps
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>

          {/* End Date */}
          <Grid item xs={12} sm={6} md={3}>
            <LabelText text="End Date" />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={date?.endDate}
                minDate={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => {
                  setDate({ ...date, endDate: newValue });
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    fullWidth
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      placeholder: "End Date", // force it inside inputProps
                    }}
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>

          {/* Button */}
          <Grid item xs={12} sm={6} md={3} display="flex" alignItems="flex-end">
            {date.startDate && date.endDate && selectedApp?.app_name && (
              <Button
                variant="contained"
                fullWidth
                // sx={{ backgroundColor: "#0C6A96", textTransform: "none" }}
                sx={{
                  backgroundColor: "#000",
                  "&:hover": { backgroundColor: "#000" },
                  textTransform: "none",
                }}
                onClick={dateWiseUser}
              >
                Find Data
              </Button>
            )}
          </Grid>
        </Grid>

        <Paper
          sx={{
            marginTop: 6,
            bgcolor: "#fff",
            "& .super-app-theme--header": {
              background: "rgba(254, 206, 113, 0.16)",
              color: "#000",
              borderBottom: " 1px solid #000",
              fontFamily: "Open Sans",
              fontSize: "13px",
            },
          }}
          elevation={0}
        >
          <DataGrid
            sx={{
              border: " 1px solid #000",
              "& .MuiDataGrid-row:hover": {
                background: "rgba(254, 206, 113, 0.16)",
                cursor: "pointer",
              },
            }}
            getRowHeight={({ densityFactor }) => {
              return 70 * densityFactor;
            }}
            autoHeight
            rows={data?.transactions || []}
            columns={AppColumns}
            getRowId={(row) => row._id}
            disableSelectionOnClick
            experimentalFeatures={{ newEditingApi: true }}
            pagination
            rowsPerPageOptions={[25, 50, 75, 100]}
            disableColumnSelector
            loading={listLoading ? <LoadingUI /> : false}
            onCellClick={(params) => {
              setPublisher_id(params?.row?._id);
            }}
            components={{
              NoRowsOverlay: () => <NoDataFound />,
              // Toolbar: GridToolbar,
            }}
            rowCount={total}
            paginationModel={setPageState}
            page={pageState.page}
            pageSize={pageState.pageSize}
            paginationMode="server"
            onPageChange={(newPage) => {
              setPageState((old) => ({ ...old, page: newPage }));
            }}
            onPageSizeChange={(newPageSize) =>
              setPageState((old) => ({ ...old, pageSize: newPageSize }))
            }
          />
        </Paper>
      </BodyWapperUI>
    </>
  );
};

export default ChargeBack;
